module.exports = __webpack_public_path__ + "static/media/sirimg.74f1f9ec.webp";